import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-tabs', 'selectTab', 'Выбрать вкладку');
